/**
 * AbilityID enum - All ability definition IDs
 */
export enum AbilityID {
    Heal = 'heal',
    GreaterHeal = 'greater_heal',
    Fireball = 'fireball',
    IceShard = 'ice_shard',
    Blizzard = 'blizzard',
    ChristmasSpirit = 'christmas_spirit',
    Identify = 'identify',
    Teleport = 'teleport',
    SummonSnowman = 'summon_snowman',
    GiftOfWarmth = 'gift_of_warmth',
}
